import { useState, useCallback } from 'react'
import type { Post, QuoteContext } from '@/types/posts'
import { usePlatform } from '@/hooks/usePlatform'

export function useQuoteModal() {
    const [quoteContext, setQuoteContext] = useState<QuoteContext | null>(null)
    const { activeAccount, setSelectedProtocol } = usePlatform()

    const handleQuote = useCallback(
        (post: Post) => {
            if (post.isActivityPub) {
                // Mastodon quotes use mastodonStatusId
                if (!post.mastodonStatusId) return
                const targetPlatform = post.protocol ?? 'mastodon'
                // Only switch if the active account is not already on the target platform,
                // otherwise setSelectedProtocol would pick the first matching account
                // instead of preserving the currently active one.
                if (activeAccount?.platform !== targetPlatform) {
                    setSelectedProtocol(targetPlatform)
                }
                setQuoteContext({ uri: post.uri, mastodonStatusId: post.mastodonStatusId, post })
            } else {
                // AT Protocol quotes require cid for embed.record
                if (!post.cid) return
                if (activeAccount?.platform !== 'bluesky') {
                    setSelectedProtocol('bluesky')
                }
                setQuoteContext({ uri: post.uri, cid: post.cid, post })
            }
        },
        [activeAccount, setSelectedProtocol]
    )

    const closeQuote = useCallback(() => setQuoteContext(null), [])

    return { quoteContext, handleQuote, closeQuote }
}
